import { MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { GraphError } from "@app/sp-data";

/** Traduce gli errori più comuni in messaggi comprensibili per l'utente. */
export function describeError(error: unknown): { title: string; detail: string } {
  if (error instanceof GraphError) {
    if (error.isForbidden)
      return { title: "Accesso negato", detail: "Non hai i permessi necessari su questo sito o elenco SharePoint." };
    if (error.isNotFound)
      return {
        title: "Elemento non trovato",
        detail: "L'elenco o la raccolta potrebbe non essere stato creato su questo sito (eseguire il provisioning).",
      };
    if (error.isConflict)
      return { title: "Modifica concorrente", detail: "Qualcun altro ha modificato questo elemento. Ricarica e riprova." };
    if (error.status === 400 && /invalid ?request/i.test(`${error.code} ${error.message}`))
      return {
        title: "Dati rifiutati da SharePoint",
        detail: "SharePoint ha rifiutato i dati (Invalid request). Di solito un testo è più lungo di quanto la colonna consente (255 caratteri per i campi su una riga).",
      };
    return { title: `Errore SharePoint (${error.status})`, detail: error.message };
  }
  return { title: "Si è verificato un errore", detail: error instanceof Error ? error.message : String(error) };
}

export function ErrorState({ error }: { error: unknown }) {
  const { title, detail } = describeError(error);
  return (
    <MessageBar intent="error" style={{ margin: 16 }}>
      <MessageBarBody>
        <MessageBarTitle>{title}</MessageBarTitle>
        {detail}
      </MessageBarBody>
    </MessageBar>
  );
}
